// extracted by mini-css-extract-plugin
export default {"terms":"TermsAndPolicy_terms__3uwGh","content":"TermsAndPolicy_content__3dSoo","btn":"TermsAndPolicy_btn__GxiDc"};